export default __webpack_public_path__ + "static/media/中.11117ef7.png";